import React from 'react';
import GeneralHelpers from 'lib/helpers/GeneralHelpers';
import getOrganizationsQuery from 'ApolloClient/Queries/getOrganizations';
import { graphql } from 'react-apollo';
import Select from 'components/inputs/Select';

// CONSTANTS AND DESTRUCTURING
// ================================================================
const Option = Select.Option;

// EXPORTED COMPONENT
// ================================================================
const OrganizationsInput = props => {
  const { onChange, value } = props;
  if (props.getOrganizationsQuery.loading || props.getOrganizationsQuery.error) {
    return null;
  }
  const optionChildren = props.getOrganizationsQuery.getOrganizations.map(org => (
    <Option key={org._id} value={org._id}>
      {org.title}
    </Option>
  ));

  return (
    <Select
      onChange={onChange}
      value={value}
      showSearch
      size="large"
      optionFilterProp="children"
      filterOption={GeneralHelpers.selectSearchFilter}
    >
      {optionChildren}
    </Select>
  );
};

// EXPORT
// ================================================================
export default graphql(getOrganizationsQuery, { name: 'getOrganizationsQuery' })(OrganizationsInput);



// WEBPACK FOOTER //
// ./src/components/inputs/OrganizationsInput/index.js